/**
 * GET `admin/whatsapp/templates` — общие шаблоны платформы.
 *
 * Постраничности нет и не нужно: шаблонов десятки, и все они заведены
 * нами вручную в кабинете Meta.
 */

import {http} from '@services/utils';

import {asObj, toTemplate} from '../toTemplate';
import type {Template} from '../types';

export const getTemplates = async (): Promise<Template[]> => {
  const r = asObj(await http('admin/whatsapp/templates', {skipCaseConversion: true}));
  return (Array.isArray(r.list) ? r.list : []).map(toTemplate);
};
